/* tslint:disable */
/* eslint-disable */
/**
 * Token.WebApi v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface EventOccurrenceDto
 */
export interface EventOccurrenceDto {
  /**
   *
   * @type {string}
   * @memberof EventOccurrenceDto
   */
  eventId: string;
  /**
   *
   * @type {Date}
   * @memberof EventOccurrenceDto
   */
  dateTimeStart: Date;
  /**
   *
   * @type {Date}
   * @memberof EventOccurrenceDto
   */
  dateTimeStop: Date;
}

/**
 * Check if a given object implements the EventOccurrenceDto interface.
 */
export function instanceOfEventOccurrenceDto(
  value: object,
): value is EventOccurrenceDto {
  if (!('eventId' in value) || value['eventId'] === undefined) return false;
  if (!('dateTimeStart' in value) || value['dateTimeStart'] === undefined)
    return false;
  if (!('dateTimeStop' in value) || value['dateTimeStop'] === undefined)
    return false;
  return true;
}

export function EventOccurrenceDtoFromJSON(json: any): EventOccurrenceDto {
  return EventOccurrenceDtoFromJSONTyped(json, false);
}

export function EventOccurrenceDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EventOccurrenceDto {
  if (json == null) {
    return json;
  }
  return {
    eventId: json['eventId'],
    dateTimeStart: new Date(json['dateTimeStart']),
    dateTimeStop: new Date(json['dateTimeStop']),
  };
}

export function EventOccurrenceDtoToJSON(json: any): EventOccurrenceDto {
  return EventOccurrenceDtoToJSONTyped(json, false);
}

export function EventOccurrenceDtoToJSONTyped(
  value?: EventOccurrenceDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    eventId: value['eventId'],
    dateTimeStart: value['dateTimeStart'].toISOString(),
    dateTimeStop: value['dateTimeStop'].toISOString(),
  };
}
